<template>
  <div>
    <p class="title">Top 5 Case Creators ({{ lastXDays }})</p>
    <table class="table table-sm">
      <thead>
        <tr>
          <th>Name</th>
          <th class="count">Cases</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="[userName, caseCount] in list" :key="userName">
          <td>{{ userName }}</td>
          <td class="count">{{ caseCount }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref, watch } from "vue";

const processData = ({ aggregateBy, data, size }) => {
  return Object.entries(
    data
      .map(item => item[aggregateBy])
      .reduce((reduction, item) => {
        if (reduction[item] === undefined) {
          reduction[item] = 0;
        }

        reduction[item] += 1;

        return reduction;
      }, {})
  )
    .sort((itemA, itemB) => {
      const [, countA] = itemA;
      const [, countB] = itemB;

      return countB - countA;
    })
    .slice(0, size);
};

export default {
  props: {
    aggregateBy: {
      default: "",
      type: String
    },
    data: {
      default: () => [],
      type: Array
    },
    size: {
      default: "",
      type: String
    },
    timespan: {
      type: String,
      default: "month"
    }
  },

  setup: props => {
    let list = ref(processData({ aggregateBy: props.aggregateBy, data: props.data, size: Number(props.size) }) || []);

    let lastXDays;

    if (props.timespan === "month") {
      lastXDays = "Last 30 days";
    } else {
      lastXDays = "Last 7 days";
    }

    watch(
      () => props.data,
      newData => {
        list.value = processData({ aggregateBy: props.aggregateBy, data: newData, size: Number(props.size) });
      }
    );

    return {
      lastXDays,
      list
    };
  }
};
</script>

<style scoped>
.count {
  text-align: right;
  width: 10rem;
}
.title {
  font-size: 1.2rem;
  letter-spacing: -0.25px;
}
</style>
